import React from 'react'
import PropTypes from 'prop-types'

import { Picture } from '@aok/image'

import AppleStoreLogo from '../../../images/app-store-badge.svg'
import GooglePlayStoreLogo from '../../../images/play-store-badge.svg'

import AllroundContainer from '../../_layouts/AllroundContainer'
import defaultProps from '../../../utils/propTypes/defaultProps'
import CopyrightLabel from '../../atoms/CopyrightLabel/CopyrightLabel'

import M035 from './../M035/M035'
import { videoPropTypes } from '../../../utils/propTypes/mediaObjects'

const appStore = {
  APPLE: 'apple',
  GOOGLE: 'google',
}

const T002 = ({ appIcon, image, showTabletHint, description, downloadStores, className, video }) => {
  return (
    <div
      className={`w-full relative ${
        image ? 'pb-48 600:pb-64 840:pb-80' : 'py-48 600:py-64 840:py-80 bg-e8f4f2'
      } ${className}`}
      data-tracking-name="T002"
    >
      {image && (
        <>
          <div className="bg-e8f4f2 absolute bottom-0 right-0 w-full h-full t002Background"></div>
          <div
            className="
        w-full relative mb-24 aspect-3/2
        600:mb-32 600:aspect-3/1
        840:mb-48
        1280:mb-64
        1440:w-1440 1440:mx-auto"
          >
            <Picture loading="eager" {...image} imgClassName="object-cover w-full h-full" />
            {image.copyright && (
              <CopyrightLabel
                text={image.copyright}
                className="bg-40484d bg-opacity-80 mt-2 mr-2 mb-2 text-14 px-16 py-8 absolute font-light leading-20 bottom-0 right-0"
              />
            )}
          </div>
        </>
      )}
      <AllroundContainer dataTrackingName="T002" className="relative">
        <div className="840:flex 840:gap-32">
          {appIcon && (
            <Picture
              {...appIcon}
              className="float-left mr-16 w-70 600:shrink-0 600:mr-24 600:w-68 840:mr-0 840:w-130 1280:w-176"
            />
          )}

          <div className="840:flex 840:justify-between 1280:pt-16">
            <div className="600:flex 600:flex-col 840:w-2/3">
              {/* App description */}
              <p className="w-full font-buenos-aires font-regular text-293033 text-24 leading-32 1280:leading-36">
                {description}
              </p>

              {/* Tablet/Smartphone hint */}
              {showTabletHint && (
                <p className="flex w-full relative items-center mt-16 font-buenos-aires-text font-regular text-828b91 text-14 leading-20">
                  Für Tablet und Smartphone verfügbar.
                </p>
              )}
            </div>

            <div
              className={`
                mt-32 flex flex-row gap-x-16 gap-y-24
                600:ml-92
                840:flex-col 840:items-end 840:mt-0 800:ml-0
              `}
            >
              {/* App store links */}
              {downloadStores.map((store, index) => {
                return (
                  <a key={index} href={store.url} className="w-auto">
                    {store.type === appStore.APPLE && <img src={AppleStoreLogo} alt="Apple Store" className="h-40" />}
                    {store.type === appStore.GOOGLE && (
                      <img src={GooglePlayStoreLogo} alt="Google Play Store" className="h-40" />
                    )}
                  </a>
                )
              })}
            </div>
          </div>
        </div>
        {!!video && (
            <div className="mt-38 760:mt-48 1000:mt-64 1440:mt-80">
              <M035 {...{video: video}} context="t002" />
            </div>
        )}
      </AllroundContainer>
    </div>
  )
}

T002.propTypes = {
  video: PropTypes.shape(videoPropTypes),
  appIcon: PropTypes.shape({
    variants: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        breakpoint: PropTypes.number,
      })
    ),
    alt: PropTypes.string,
  }),
  image: PropTypes.shape({
    variants: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        breakpoint: PropTypes.number,
      })
    ),
    alt: PropTypes.string,
    copyright: PropTypes.string,
    contentUrl: PropTypes.string,
  }),
  showTabletHint: PropTypes.bool,
  description: PropTypes.string,
  downloadStores: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      type: PropTypes.oneOf([appStore.APPLE, appStore.GOOGLE]),
    })
  ),
}

T002.defaultProps = {
  className: '',
  showTabletHint: false,
  description: defaultProps.DESCRIPTION,
  downloadStores: [],
  video: {
    id: 'abc',
    playerType: 'youtube',
    name: defaultProps.NAME,
    description: defaultProps.DESCRIPTION,
    uploadDate: defaultProps.DATE,
  },
}

export default T002
